// 竞标：简体中文字段。只维护显示文案，不改业务标识、数值或提交内容。

// 竞标页面
export const page = Object.freeze({
  "bidPage.filterConditions": "筛选条件",
  "bidPage.allBids": "全部竞标",
  "bidPage.clear": "清空",
  "bidPage.filter": "筛选",
  "bidPage.allFilters": "全部筛选",
  "bidPage.closeFilters": "关闭筛选",
  "bidPage.productBrand": "产品品牌",
  "bidPage.goodsLocation": "货所在地",
  "bidPage.goodsCondition": "货物情况",
  "bidPage.allCategories": "全部产品分类",
  "bidPage.allBrands": "全部品牌",
  "bidPage.allLocations": "全部地区",
  "bidPage.allConditions": "全部情况",
  "bidPage.reset": "重置",
  "bidPage.done": "完成",
  "bidPage.statistics": "统计",
  "bidPage.manage": "管理",
  "bidPage.post": "发布",
  "bidPage.bidding": "竞标",
  "bidPage.bidStatistics": "截标统计",
  "bidPage.partNumbers": "截标料号",
  "bidPage.bidUsers": "竞标用户",
  "bidPage.table": "列表",
  "bidPage.loading": "加载中...",
  "bidPage.empty": "暂无相关供需信息",
  "bidPage.trend": "价格趋势",
  "bidPage.trendFor": "{partNumber} 价格趋势",
  "bidPage.currentPrice": "当前价格",
  "bidPage.lastPeriod": "较上期",
  "bidPage.recentHigh": "近期最高",
  "bidPage.recentLow": "近期最低",
  "bidPage.recentPeriods": "近6期价格走势",
  "bidPage.periodLabel": "期数：{value}",
  "bidPage.publishedAt": "发布时间",
  "bidPage.deadlineAt": "截标时间",
  "bidPage.openedAt": "开标时间",
  "bidPage.bidCount": "竞标人数",
  "bidPage.currency": "货币",
  "bidPage.referenceUnitPrice": "参考单价",
  "bidPage.share": "分享",
  "bidPage.stock": "库存",
  "bidPage.status": "状态",
  "bidPage.id": "编号",
  "bidPage.unitPrice": "参考单价",
  "bidPage.wantBid": "我要竞标",
  "bidPage.unknown": "未知",
  "bidPage.companyMissing": "未填写公司",
  "bidPage.statisticsLoadFailed": "竞标统计加载失败，请稍后重试",
  "bidPage.listLoadFailed": "竞标列表加载失败，请稍后重试",
  "bidPage.referencePrice": "参考价格",
  "bidPage.statisticsEmpty": "暂无竞标统计数据",
  "bidPage.brandPrefix": "品牌：",
  "bidPage.categoryPrefix": "产品分类：",
  "bidPage.technologyPrefix": "技术：",
  "bidPage.capacityPrefix": "容量：",
  "bidPage.locationPrefix": "货所在地：",
  "bidPage.packagingPrefix": "包装：",
  "bidPage.packagePrefix": "封装：",
  "bidPage.periodPrefix": "期数：",
  "bidPage.idPrefix": "编号：",
  "bidPage.deadlinePrefix": "截标：",
  "bidPage.submittedForReview": "已提交审核",
  "bidPage.lowestQuote": "最低报价",
  "bidPage.totalBidQuantity": "竞标总数量",
  "bidPage.selectPart": "全选本料号",
  "bidPage.select": "选择",
  "bidPage.rank": "排名",
  "bidPage.lastBidAt": "最后竞标时间",
  "bidPage.totalBidAmount": "竞标总金额",
  "bidPage.selectedSummary": "所选竞标汇总",
  "bidPage.selected": "已选",
  "bidPage.usersUnit": "位用户",
  "bidPage.clearSelection": "清空选择",
  "bidPage.totalQtyEditable": "总数量（可修改）",
  "bidPage.lowestEditable": "最低价（可修改）",
  "bidPage.selectedLowest": "选中最低竞标价：",
  "bidPage.feeMode": "费用方式",
  "bidPage.external": "外收",
  "bidPage.feeRateEditable": "费用比例（可修改）",
  "bidPage.selectedAmount": "所选竞标金额：",
  "bidPage.fee": "费用：",
  "bidPage.settlement": "结算金额：",
  "bidPage.updateReview": "更新审核数据",
  "bidPage.addReview": "加入审核汇总",
  "bidPage.confirmScope": "确认范围",
  "bidPage.allPeriods": "全部期数（{count} 个）",
  "bidPage.periodCount": "{period}（{count} 个）",
  "bidPage.addedReview": "已加入审核汇总",
  "bidPage.partsUnit": "个料号，共涉及",
  "bidPage.periodsUnit": "个期数",
  "bidPage.partsAndPeriods": "{parts} 个料号，共涉及 {periods} 个期数",
  "bidPage.confirmAll": "确认全部",
  "bidPage.confirmPeriod": "确认本期",
  "bidPage.loadMore": "加载更多...",
  "bidPage.noMore": "没有更多数据了",
  "bidPage.selectedRows": "已选择 {count} 条",
  "bidPage.rowsUnit": "条",
  "bidPage.approve": "审核通过",
  "bidPage.statisticsLoadError": "竞标统计加载失败",
  "bidPage.listLoadError": "竞标列表加载失败",
  "bidPage.chooseReviewUsers": "请先选择需要提交审核的竞标用户",
  "bidPage.invalidSettlement": "请填写有效的总数量和最低价",
  "bidPage.reviewAddedNotice": "已加入审核汇总，请在页面底部统一确认",
  "bidPage.invalidAuditNumber": "截标审核单号返回异常，请从竞标审核列表查看",
  "bidPage.createAuditFailed": "生成截标审核单失败，请重试",
  "bidPage.approveConfirm": "确定审核通过选中的 {count} 条信息吗？",
  "bidPage.approveTitle": "审核确认",
  "bidPage.confirmApprove": "确定审核",
  "bidPage.cancel": "取消",
  "bidPage.approveSuccess": "已审核通过 {count} 条信息",
  "bidPage.deleteConfirm": "确定删除选中的 {count} 条信息吗？此操作不可恢复！",
  "bidPage.deleteTitle": "删除确认",
  "bidPage.confirmDelete": "确定删除",
  "bidPage.deleteFailed": "删除失败",
  "bidPage.deleteSuccess": "已删除 {count} 条信息",
  "bidPage.specMissingFields": "当前竞标缺少品牌或料号，无法匹配商品百科",
  "bidPage.specNotFound": "未找到对应商品百科",
  "bidPage.specLookupFailed": "查询商品百科失败，请稍后重试",
  "bidPage.noData": "暂无数据",
  "bidPage.copied": "已复制到剪切板",
  "bidPage.copyFailed": "复制失败，请手动复制",
  "bidPage.unfavorited": "已取消收藏",
  "bidPage.favorited": "收藏成功，已同步到个人中心",
  "bidPage.loginToBid": "请先登录后再竞标",
  "bidPage.loginToPost": "请先登录后再发布竞标",
  "bidPage.closedCannotEdit": "当前竞标已结束，不能修改报价",
  "bidPage.invalidQuote": "请输入有效的报价",
  "bidPage.invalidQuantity": "请输入有效的需求数量，不能超过库存",
  "bidPage.submitFailed": "竞价提交失败",
  "bidPage.submitRetry": "竞价提交失败，请稍后重试",
  "bidPage.submitSuccess": "竞价提交成功",
  "bidPage.shareCopied": "分享链接已复制到剪贴板",
  "bidPage.dayCountdown": "{days}天 {time}",
  "bidPage.locationHongKong": "中国香港",
  "bidPage.locationMainland": "中国大陆",
  "bidPage.locationBonded": "保税区",
  "bidPage.conditionOriginalFactory": "原厂",
  "bidPage.conditionOriginalBox": "原箱",
  "bidPage.conditionOriginalGoods": "原装",
  "bidPage.conditionOriginalPack": "原包",
  "bidPage.conditionOriginalLabel": "原标",
  "bidPage.edit": "编辑",
  "bidPage.pendingPublish": "待发布",
  "bidPage.changeBid": "修改竞标",
  "bidPage.awaitOpening": "待开标",
});

// 个人竞标
export const personal = Object.freeze({
  "biddingPersonal.followTitle": "我的跟单",
  "biddingPersonal.followerTitle": "我的跟单员",
  "biddingPersonal.followDescription": "查看被邀请人的竞标参与状态与开标结果",
  "biddingPersonal.followerDescription":
    "查看跟单员及关联竞标，可在截标前参与或修改竞标信息",
  "biddingPersonal.searchFollow": "搜索型号/品牌",
  "biddingPersonal.searchFavorite": "搜索料号/品牌",
  "biddingPersonal.filterAll": "全部",
  "biddingPersonal.filterBidding": "竞标中",
  "biddingPersonal.filterWaiting": "待开标",
  "biddingPersonal.filterOpened": "已开标",
  "biddingPersonal.stageInvited": "未参与竞标",
  "biddingPersonal.stageBidding": "竞标中",
  "biddingPersonal.stageWaiting": "等待开标",
  "biddingPersonal.stageWon": "已中标",
  "biddingPersonal.stageLost": "未中标",
  "biddingPersonal.exclusiveFollower": "专属跟单员",
  "biddingPersonal.invitedPerson": "被邀请人",
  "biddingPersonal.follower": "跟单员",
  "biddingPersonal.submittedCount": "已提交 {count} 次",
  "biddingPersonal.establishedService": "已建立跟单服务关系",
  "biddingPersonal.relatedBid": "关联竞标 {model}",
  "biddingPersonal.viewFollower": "查看跟单员",
  "biddingPersonal.noFollowUsers": "暂无跟单用户",
  "biddingPersonal.noFollowers": "暂无跟单员",
  "biddingPersonal.followUser": "跟单用户",
  "biddingPersonal.bidModel": "竞标型号",
  "biddingPersonal.currentStage": "当前阶段",
  "biddingPersonal.submissionCount": "提交次数",
  "biddingPersonal.times": "{count} 次",
  "biddingPersonal.updatedAt": "状态更新时间",
  "biddingPersonal.followUserDetail": "跟单用户详情",
  "biddingPersonal.followerDetail": "我的跟单员详情",
  "biddingPersonal.myFollowUser": "我负责跟进的用户",
  "biddingPersonal.myFollower": "为我服务的跟单员",
  "biddingPersonal.companyMissing": "未填写公司",
  "biddingPersonal.relationshipAt": "建立关系于",
  "biddingPersonal.serving": "服务中",
  "biddingPersonal.bidFlow": "竞标流程",
  "biddingPersonal.autoUpdated": "由竞标状态自动更新",
  "biddingPersonal.relationshipEstablished": "已建立关系",
  "biddingPersonal.participated": "参与竞标",
  "biddingPersonal.waitingOpen": "等待开标",
  "biddingPersonal.relatedBidTitle": "关联竞标",
  "biddingPersonal.viewBid": "查看竞标",
  "biddingPersonal.brandCategory": "品牌 / 分类",
  "biddingPersonal.requiredQuantity": "需求数量",
  "biddingPersonal.submissionRecords": "提交记录",
  "biddingPersonal.deadline": "截标时间",
  "biddingPersonal.openAt": "开标时间",
  "biddingPersonal.bidActivity": "竞标动态",
  "biddingPersonal.recentUpdate": "最近更新：{time}",
  "biddingPersonal.close": "关闭",
  "biddingPersonal.myFavorites": "我的收藏",
  "biddingPersonal.supply": "供应",
  "biddingPersonal.demand": "需求",
  "biddingPersonal.purchase": "求购",
  "biddingPersonal.unfavorite": "取消收藏",
  "biddingPersonal.category": "分类",
  "biddingPersonal.condition": "货态",
  "biddingPersonal.favoriteAt": "收藏时间",
  "biddingPersonal.noFavorites": "暂无收藏的供需信息",
  "biddingPersonal.hintInvited": "已建立关系，尚未提交竞标信息",
  "biddingPersonal.hintBidding": "截标前可以多次修改，以最后一次提交为准",
  "biddingPersonal.hintWaiting": "已截标，等待平台开标",
  "biddingPersonal.hintWon": "已开标，本次竞标中标",
  "biddingPersonal.hintLost": "已开标，本次竞标未中标",
  "biddingPersonal.hintDefault": "查看竞标状态",
  "biddingPersonal.openResult": "开标结果",
  "biddingPersonal.logRelation": "建立跟单关系",
  "biddingPersonal.logRelationDetail": "{name}通过竞标分享邀请建立关系",
  "biddingPersonal.logSubmission": "提交竞标信息",
  "biddingPersonal.logSubmissionDetail":
    "被邀请人已提交第 {count} 次竞标信息，截标前仍可修改",
  "biddingPersonal.logWon": "本次竞标已中标",
  "biddingPersonal.logLost": "本次竞标未中标",
  "biddingPersonal.customer": "客户",
});

export const messages = Object.freeze({ ...page, ...personal });
